import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private appConfig: any;
  private configFile: any;

  httpClient = inject(HttpClient);
  constructor() {
    this.getConfigFileName();
  }

  loadAppConfig() {
    return this.httpClient
      .get('assets/config/' + this.configFile)
      .toPromise()
      .then(data => {
        this.appConfig = data;
      });
  }
  getConfigFileName(): void {
    if (environment.state === 'development') {
      this.configFile = 'development.json';
    }
    if (environment.state === 'dhofar') {
      this.configFile = 'dhofar.json';
    }
    if (environment.state === 'production') {
      this.configFile = 'production.json';
    }
    if (environment.state === 'stage') {
      this.configFile = 'staging.json';
    }
  }

  getServerUrl(): string {
    return this.appConfig.HOST_API;
  }
  getAppUrl(key: string): any {
    return this.appConfig[key];
  }
}
